import { track } from "jiffy-analytics";
import { api } from "jiffy-api";
import EventClass from "common/utils/ui/event-class";
import "./digital-assets-my-library-toggle.scss";

export class MyLibraryToggle extends EventClass {
  #saveLibraryCallback;

  #signedInSelector = ".js-product-details-favorite-sign-in";

  constructor(props) {
    super(props);

    this.#saveLibraryCallback = props.saveLibraryCallback;
  }

  // eslint-disable-next-line class-methods-use-this
  get #statesCollection() {
    return window.saved_design_ids || [];
  }

  #showSignInModal() {
    const $$modal = $(this.#signedInSelector);
    $$modal.modal("show");
  }

  // eslint-disable-next-line class-methods-use-this
  #updateState($button, isActive) {
    $button?.setAttribute("aria-pressed", isActive ? "true" : "false");
    $button?.parentNode?.classList.toggle("active", isActive);
  }

  async event(_, target) {
    const { libraryAssetId, signedIn, sku, author, slug, context, pageName } = target.dataset;
    const isActive = target.getAttribute("aria-pressed") === "true";

    if (signedIn === "false") {
      this.#showSignInModal();
      return;
    }

    const { success } = await api.digitalAssets.setToMyLibrary(
      { slug: libraryAssetId },
      { save: !isActive }
    );

    if (success) {
      this.#updateState(target, !isActive);

      track("digital_asset_my_library_toggle_click", {
        saved: !isActive,
        author,
        click_context: context,
        page_name: pageName,
        product: slug,
        digital_asset_id: libraryAssetId,
        sku
      });

      this.#saveLibraryCallback?.(!isActive);
    }
  }

  init() {
    this.#statesCollection.forEach(libraryAssetId => {
      const $button = document.querySelector(`[data-library-asset-id="${libraryAssetId}"]`);
      this.#updateState($button, true);
    });
  }
}

export default props =>
  new MyLibraryToggle({
    eventSelector: ".js-digital-assets-my-library-toggle",
    ...props
  });
